import React from "react";
import { Link } from "react-router-dom";
import "./AgentBioMissing.scss";

const AgentBioMissing = ({ unreachable = false }) => (
  <section className="agent-bio-missing" role="status">
    <h1>{unreachable ? "We couldn't load this agent's page" : "We couldn't find this agent's page"}</h1>
    <p>
      {unreachable
        ? "Check your connection and try again in a minute, or find the agent in the agent directory."
        : "The link may be old, or the agent may have changed it. Search for them by name or town in the agent directory."}
    </p>
    <Link className="btn btn-primary" to="/agents">
      Open the agent directory
    </Link>
  </section>
);

export default AgentBioMissing;
